import { ContentLibraryOpenedWhiteboard } from 'features/content-library/types';
import { formatToWhiteboardFile } from 'features/content-library/utils/format';
import { ContentData } from 'features/layout/features/content/types';
import { OpenedWhiteboard } from 'features/room/types';
import {
  ContentProcessingResult,
  createProcessingState,
  trackLatestAndLocked,
} from './contentProcessing';

export type ProcessedWhiteboards = ContentProcessingResult<
  Record<string, ContentLibraryOpenedWhiteboard>,
  ContentLibraryOpenedWhiteboard
>;

export function processOpenedWhiteboardsForRoom(
  openedWhiteboards: OpenedWhiteboard[] | null,
  lockedContent: ContentData | null
): ProcessedWhiteboards {
  const whiteboards: Record<string, ContentLibraryOpenedWhiteboard> = {};
  const state = createProcessingState<ContentLibraryOpenedWhiteboard>();

  const lockedId = lockedContent?.type === 'whiteboard' ? lockedContent.id : null;

  if (openedWhiteboards) {
    for (const whiteboard of openedWhiteboards) {
      const whiteboardData = formatToWhiteboardFile(whiteboard);
      const timestamp = Number(new Date(whiteboard.date));

      whiteboards[whiteboard.id] = whiteboardData;
      trackLatestAndLocked(whiteboardData, whiteboard.id, timestamp, lockedId, state);
    }
  }

  return {
    collection: whiteboards,
    ...state,
  };
}
